const risks = [
  { problem: 'Fałszywy produkt', solution: 'Weryfikacja przez społeczność – każdy produkt w arkuszu jest sprawdzony przez innych kupujących', problemIcon: 'ri-alert-line', solutionIcon: 'ri-shield-check-line' },
  { problem: 'Brak zdjęć QC', solution: 'Zdjęcia jakości dostępne dla każdego produktu – zobacz rzeczywisty wygląd przed zakupem', problemIcon: 'ri-image-line', solutionIcon: 'ri-camera-lens-line' },
  { problem: 'Niepewny sprzedawca', solution: 'Oceny i recenzje sprzedawców – kupuj tylko od sprawdzonych dostawców', problemIcon: 'ri-user-unfollow-line', solutionIcon: 'ri-user-star-line' },
  { problem: 'Problemy z wysyłką', solution: 'Szczegółowe informacje o metodach wysyłki do Polski i szacowanych czasach dostawy', problemIcon: 'ri-ship-line', solutionIcon: 'ri-map-pin-line' },
];

export default function SafetySection() {
  return (
    <section id="bezpieczenstwo" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
            Bezpieczeństwo
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Czy Kakobuy Spreadsheet jest bezpieczny?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-3xl mx-auto">
            Bezpieczeństwo zakupów to priorytet. Kakobuy Spreadsheet został zaprojektowany tak, aby minimalizować ryzyko i pomagać w podejmowaniu świadomych decyzji zakupowych.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {risks.map((item, i) => (
            <div key={i} className="flex gap-4 p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="flex flex-col items-center gap-2 flex-shrink-0">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className={`${item.problemIcon} text-lg`}></i>
                </div>
                <span className="text-[10px] text-foreground-500">Problem</span>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground-900 mb-1">{item.problem}</p>
                <div className="flex items-start gap-2 mt-3 pt-3 border-t border-background-200/70">
                  <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <i className={`${item.solutionIcon} text-xs`}></i>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.solution}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}